module.exports = "<div class=\"table table-2\">\r\n    <h5 class=\"title-table\">Future Vaccination(s)</h5>\r\n    <table datatable [dtOptions]=\"dtOptions\" id=\"vaccine_2\" class=\"display responsive nowrap\" cellspacing=\"0\" width=\"100%\">\r\n    </table>\r\n  </div>\r\n  "


//////////////////
// WEBPACK FOOTER
// D:/TMB/TMB/MYTMB.UI/src/app/pages/admin-vaccine/future-vaccine/future-vaccine.component.html
// module id = ../../../../../src/app/pages/admin-vaccine/future-vaccine/future-vaccine.component.html
// module chunks = main